import type { City, CompanyBrief, CompanyFull } from '../companies/types'
import type { CareerPath } from '../career-paths/types'

export interface JobOffer {
  id: number
  company: CompanyBrief | Partial<CompanyFull>
  careerPaths: CareerPath[]
  divisionId?: number
  subDivisionId?: number
  title: string
  description: string
  city: City
  workShiftType?: WorkShift
  workTypes: WorkType[]
  isInternship: boolean
  isRecruitingEvent: boolean
  externalLink: string
  applyDateLimit?: string
  startDateInfo?: string
  details: JobOfferDetails
  contactPerson?: string
  requirements?: string
  resources?: JobOfferResource[]
  lastPublishedAt: Date
  isExternal: boolean
  applicationFields?: ApplicationField[]
  confirmLocation?: boolean
}

export enum ApplicationFieldTypes {
  ACADEMIC_TRANSCRIPT = 'academic_transcript',
  COVER_LETTER = 'cover_letter',
  LANGUAGE_LEVEL = 'language_level',
}

export interface ApplicationField {
  name: string
  isRequired: boolean
  /** When name is language_level: required language codes (e.g. ['en', 'de']) */
  values?: string[]
}

export type JobOfferDetails = FullTimeDetails | InternshipDetails
export interface JobOfferCommonDetails {
  salary: string
}
export interface FullTimeDetails extends JobOfferCommonDetails {
  experience: string
}
export interface InternshipDetails extends JobOfferCommonDetails{
  duration: string
  isCurricular: boolean
  hasAgreement: boolean
}

export interface WorkShift {
  id: number
  name: string
}

export interface WorkType {
  id: number
  name: string
}

export interface JobOfferResource {
  link: string
  label: string
}

export interface JobOfferFilter {
  sortBy?: string
  text?: string | null
  careerPathIds?: string[]
  contractType?: ContractType[]
  workShiftIds?: string[]
  contractDetails?: string[]
  cityIds: string[]
  myJobOffers: boolean
  isInternal: boolean
  hideFilterMyJobOffers?: boolean
  hideFilterIsInternal?: boolean
}

export enum ContractType {
  INTERNSHIP = 'INTERNSHIP',
  FULL_TIME = 'FULL_TIME',
}

export enum ContractDetails {
  INTERNSHIP_CURRICULAR = 'INTERNSHIP_CURRICULAR',
  INTERNSHIP_AGREEMENT = 'INTERNSHIP_AGREEMENT',
}

export interface UserCv {
  srcUrl: string
}

export interface UserAcademicTranscript {
  id: number
  srcUrl: string
}

export interface LatestAcademicTranscript {
  id: number
  srcUrl: string
}

export interface JobOfferApplicationLanguageLevel {
  code: string
  level: number
}

export interface JobOfferApplication {
  jobOfferId: number
  professionalContext: string
  cv: File | null | UserCv
  academicTranscript?: File | null | UserAcademicTranscript
  academicTranscriptId?: number
  coverLetter?: File | null
  canSignInternshipAgreement?: boolean
  /** Language levels required by the offer; saved to user profile on submit */
  languageLevels?: JobOfferApplicationLanguageLevel[]
}

export interface JobOfferEngagement {
  jobOfferId: number
}
